export const CHALLENGE_TECHNOLOGIES_DROPDOWN = [
  {
    value: 'NODEJS',
    label: 'NodeJS',
    technologyType: 'backend',
  },
  {
    value: 'PYTHON',
    label: 'Python',
    technologyType: 'backend',
  },
  {
    value: 'DOTNET',
    label: '.NET',
    technologyType: 'backend',
  },
  {
    value: 'CSHARP',
    label: 'C#',
    technologyType: 'backend',
  },
  {
    value: 'DJANGO',
    label: 'Django',
    technologyType: 'backend',
  },
  {
    value: 'FASTAPI',
    label: 'FastAPI',
    technologyType: 'backend',
  },
  {
    value: 'FLASK',
    label: 'Flask',
    technologyType: 'backend',
  },
  {
    value: 'GOLANG',
    label: 'Golang',
    technologyType: 'backend',
  },
  {
    value: 'JAVA',
    label: 'Java',
    technologyType: 'backend',
  },
  {
    value: 'JAVAEE',
    label: 'JavaEE',
    technologyType: 'backend',
  },
  {
    value: 'KOTLIN',
    label: 'Kotlin',
    technologyType: 'backend',
  },
  {
    value: 'RUST',
    label: 'Rust',
    technologyType: 'backend',
  },
  {
    value: 'SCALA',
    label: 'Scala',
    technologyType: 'backend',
  },
  {
    value: 'REACT',
    label: 'React',
    technologyType: 'frontend',
  },
  {
    value: 'VUE',
    label: 'Vue',
    technologyType: 'frontend',
  },
  {
    value: 'ANGULAR',
    label: 'Angular',
    technologyType: 'frontend',
  },
  {
    value: 'FLUTTER',
    label: 'Flutter',
    technologyType: 'mobile',
  },
  {
    value: 'OBJECTIVE_C',
    label: 'Objective C',
    technologyType: 'mobile',
  },
  {
    value: 'REACT_NATIVE',
    label: 'React Native',
    technologyType: 'mobile',
  },
  {
    value: 'SWIFT',
    label: 'Swift',
    technologyType: 'mobile',
  },
];
